import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { api, imgUrl } from "@/lib/api";
import { useLang } from "@/i18n";

export default function Brands() {
  const [brands, setBrands] = useState([]);
  const { t } = useLang();

  useEffect(() => {
    api.get("/brands").then((r) => setBrands(r.data)).catch(() => {});
  }, []);

  if (brands.length === 0) return null;

  return (
    <section
      id="brands"
      data-testid="brands-section"
      className="bg-[#0B1120] px-6 md:px-12 lg:px-24 py-20 lg:py-28 border-t border-white/5"
    >
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
        <Reveal>
          <p className="text-xs tracking-[0.25em] uppercase text-[#ED1C24] mb-4">
            {t("brands_label")}
          </p>
          <h2 className="font-display font-semibold text-white text-4xl sm:text-5xl tracking-tight">
            {t("brands_title").replace(".", "")}<span className="text-[#FFC61A]">.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Link
            data-testid="brands-shop-link"
            to="/shop"
            className="group inline-flex items-center gap-2 text-sm text-slate-300 hover:text-[#FFC61A] transition-colors duration-300 border-b border-white/20 hover:border-[#FFC61A] pb-1"
          >
            {t("brands_link")}
            <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
          </Link>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
        {brands.map((b, i) => (
          <Reveal key={b.id} delay={(i % 4) * 0.07}>
            <div
              data-testid={`brand-card-${b.id}`}
              className="group h-full border border-white/10 bg-white/[0.02] p-8 flex flex-col items-center text-center hover:border-[#ED1C24]/60 hover:-translate-y-1.5 transition-[border-color,transform] duration-500"
            >
              {b.logo ? (
                <div className="h-14 w-full flex items-center justify-center mb-5 px-4 py-2 bg-white rounded-md">
                  <img
                    src={imgUrl(b.logo)}
                    alt={b.name}
                    loading="lazy"
                    className="max-h-10 max-w-full object-contain"
                  />
                </div>
              ) : (
                <span className="font-display font-semibold text-2xl text-white/85 group-hover:text-[#ED1C24] transition-colors duration-300 mb-5">
                  {b.name}
                </span>
              )}
              {b.logo && (
                <p className="font-display font-medium text-white text-sm mb-1">{b.name}</p>
              )}
              {b.description && (
                <p className="text-xs text-slate-500 leading-relaxed">{b.description}</p>
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
